import React, { FunctionComponent } from "react";
import { Card, CardActionArea, CardMedia, CardContent, Typography, Chip, Grid, Box } from "@material-ui/core";
import Img from "gatsby-image/withIEPolyfill";
import { graphql, useStaticQuery } from "gatsby";
import styled from "styled-components";

const StyledCard = styled(Card)`
  width: 284px;
  height: 390px;
`;

const StyledMedia = styled(CardMedia)`
  height: 200px;
`;

const StyledImage = styled((props) =>(
  <Img {...props} />
))`
  height: 200px;
`;

const StyledCardContent = styled(CardContent)`
  height: 190px;
`;

const StyledTitleText = styled(Typography)`
  font-size: 1.34rem;

  height: 2.3em;

  overflow: hidden;
`;

const TitleText: FunctionComponent = (props) =>(
  <Box my={1}>
    <StyledTitleText variant="h2">
      {props.children}
    </StyledTitleText>
  </Box>
);

const StyledDescription = styled((props) =>(
  <Typography {...props} />
))`
  height: 4.1em;

  overflow: hidden;
`;

const DescriptionText: FunctionComponent = (props) =>(
  <Box mt={1} mb={2}>
    <StyledDescription variant="body2" color="textSecondary" component="p">
      {props.children}
    </StyledDescription>
  </Box>
)

type Property={
  title: string;
  description: string;
  imageFluid?: any;
  link: string;
  tag?: string;
  date: string;
}

export const ContentsCard: FunctionComponent<Property> = (props) =>{
  const data = useStaticQuery(graphql`
    query ImageForCardCover{
      file(relativePath: { eq: "logo-notext.png" }) {
        childImageSharp {
          fluid(maxWidth: 600){
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  const imageFluid = props.imageFluid || data.file.childImageSharp.fluid;

  const renderTag = (tag?: string) =>{
    if(tag){
      return(
        <Grid item>
          <Chip variant="outlined" size="small" label={tag} />
        </Grid>
      );
    }
  }

  return (
    <StyledCard>
      <CardActionArea href={props.link}>
        <StyledMedia>
          <StyledImage fluid={imageFluid} objectFit="cover"/>
        </StyledMedia>
        <StyledCardContent>
          <TitleText>{props.title}</TitleText>
          <DescriptionText>
            {props.description}
          </DescriptionText>
          <Grid container direction="row" alignItems="center" spacing={2}>
            <Grid item>
              <Typography variant="body2" component="span" color="textSecondary">
                {props.date}
              </Typography>
            </Grid>
            {renderTag(props.tag)}
          </Grid>
        </StyledCardContent>
      </CardActionArea>
    </StyledCard>
  );
}